<template>
  <q-footer
    bordered
    class="bg-grey-4 text-grey-8"
  >
    <q-toolbar>
      <q-toolbar-title>
        <small>Desenvolvido por <b>Abraão Pinto</b></small>
      </q-toolbar-title>
      <q-btn
        id="btn-user-github"
        aria-label="author's GitHub"
        flat
        round
        color="dark"
        type="a"
        href="https://github.com/abraaopinto"
        target="_blank"
        rel="noopener"
        icon="fab fa-github"
      >
      </q-btn>
      <q-btn
        id="btn-user-twitter"
        aria-label="author's Twitter"
        flat
        round
        color="blue"
        type="a"
        href="https://twitter.com/abraao_dev"
        target="_blank"
        rel="noopener"
        icon="fab fa-twitter"
      >
      </q-btn>
      <q-btn
        id="btn-user-linkedin"
        aria-label="author's Linkedin"
        flat
        round
        color="indigo-8"
        type="a"
        href="https://br.linkedin.com/in/abra%C3%A3o-pinto-8a1a06170"
        target="_blank"
        rel="noopener"
        icon="fab fa-linkedin"
      >
      </q-btn>
    </q-toolbar>
  </q-footer>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>

<style>
</style>
